import { RefreshCw, TriangleAlert } from "lucide-react";
import { useAppVersionStatus } from "@/hooks/use-app-version-status";

type AppVersionPromptProps = {
      enabled?: boolean;
};

export const AppVersionPrompt = ({ enabled = true }: AppVersionPromptProps) => {
      const { versionState } = useAppVersionStatus(enabled);

      if (!enabled || !versionState || versionState.status === "current") {
            return null;
      }

      const isBlocking = versionState.status === "update-required";

      const prompt = (
            <div className="flex w-full max-w-xs items-center gap-3 rounded-full border border-brand-ink/8 bg-background py-2 pr-2 pl-4 shadow-lg shadow-brand-ink/6">
                  {isBlocking ? (
                        <TriangleAlert className="size-4 shrink-0 text-amber-500" />
                  ) : (
                        <RefreshCw className="size-4 shrink-0 text-brand-teal" />
                  )}

                  <p className="min-w-0 flex-1 text-[13px] font-medium leading-tight text-foreground">
                        {isBlocking ? "This tab is outdated" : "New version available"}
                  </p>

                  <button
                        onClick={() => window.location.reload()}
                        className={`shrink-0 rounded-full px-4 py-1.5 text-[13px] font-semibold transition-colors ${
                              isBlocking
                                    ? "bg-brand-ink text-white hover:bg-brand-ink-deep"
                                    : "bg-brand-accent text-brand-ink hover:bg-brand-accent-hover"
                        }`}
                  >
                        Reload
                  </button>
            </div>
      );

      if (isBlocking) {
            return (
                  <div className="fixed inset-0 z-[100] flex items-center justify-center bg-brand-ink/50 px-4 backdrop-blur-sm">
                        {prompt}
                  </div>
            );
      }

      return (
            <div className="pointer-events-none fixed inset-x-0 top-4 z-[70] flex justify-center px-4">
                  <div className="pointer-events-auto animate-in slide-in-from-top-2 fade-in duration-300">
                        {prompt}
                  </div>
            </div>
      );
};
